/**
 * 環境変数が有効か？
 * @param env_item 
 * @returns true:有効
 */
export function isEnabledEnv(env_item: number|string|undefined): boolean
{
  return ( env_item == 1 || env_item == "true" || env_item == "TRUE");
}
